module.exports = __webpack_public_path__ + "static/media/pallete_gear@2x.212314b7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gear/accesories/pallete_gear@2x.png
// module id = 328
// module chunks = 0